//Базовая функция последовательных вызовом запросов, выполнящих обращение к данным
export const PromiseSequenceRunner = ([first, ...tail], props) => {
	if (first === undefined) return Promise.resolve();
	try {
	  return tail.reduce((p, deed) => p.then(deed), first(props));
	} catch (e) {
	  return Promise.reject(e);
	}
}
